import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import useSequence from './use-sequence.hook';
import Label from './Label';
import {
  BaseWrapper,
  Layer,
  Skew,
  BaseElement,
  BaseMargin,
  SPRING_CONFIGS,
} from './bits';

function MarginCollapseOpposing() {
  const [stepIndex, step, handlers] = useSequence({
    mode: 'interactive',
  });

  const firstSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : -25}%)`,
    config: SPRING_CONFIGS[0],
  });

  const secondSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : 25}%)`,
    config: SPRING_CONFIGS[0],
  });

  return (
    <Wrapper {...handlers}>
      <Layer style={{ zIndex: 2, ...firstSpring }}>
        <Skew>
          <Element>Paragraph One</Element>
          <TopMargin />
        </Skew>
        <Label
          orientation="up"
          isVisible={stepIndex === 2}
          style={{
            bottom: '33%',
            left: '-25%',
          }}
        >
          margin-bottom: 72px
        </Label>
      </Layer>

      <Layer style={{ top: 223, ...secondSpring }}>
        <Skew>
          <BottomMargin />
          <Element>Paragraph Two</Element>
        </Skew>
        <Label
          orientation="down"
          isVisible={stepIndex === 2}
          style={{
            top: '28%',
            right: '-25%',
          }}
        >
          margin-top: 24px
        </Label>
      </Layer>
    </Wrapper>
  );
}

const Wrapper = styled(BaseWrapper)`
  height: 460px;
`;

const Element = styled(BaseElement)``;
const TopMargin = styled(BaseMargin)`
  height: 72px;
`;
const BottomMargin = styled(BaseMargin)`
  height: 24px;
`;

export default MarginCollapseOpposing;
